//import React, {useState} from 'react';
import {GameData} from './types';

interface GameThumbnailProps {
    game: GameData
}

function GameThumbnail ({game}: GameThumbnailProps) {

    var containerCount = game.stateKey.split("/").length - 1;
    var tokenList = game.stateKey.replaceAll("/",",").split(","); 
    tokenList = tokenList.fill("", tokenList.length, containerCount*4);
    var idx = 0;
    
    return (
        <>
        <div className="gameThumbnail">
            {Array.from({ length: containerCount }).map((value, index) => (
                <div className="gameThumbnailContainer" key={index}>
                    {tokenList.slice(index * 4, (index + 1) * 4).map((color) => (
                            <svg xmlns="http://www.w3.org/2000/svg" height="6" width="6" key={idx++} className="thumbnailToken">
                                <circle cx="3" cy="3" r="3" fill={(color === "" ? "transparent" : color)} />
                            </svg>
                    ))}
                </div>
            ))}
        </div>
        </>
    );    
}

export default GameThumbnail;
